import React from 'react'
import initApollo from './init-apollo'
import Head from 'next/head'
import { getDataFromTree } from 'react-apollo'
import cookie from 'cookie'

export default App => {
  return class Apollo extends React.Component {
    static displayName = 'withApollo(App)'
    static async getInitialProps (ctx) {
      const { Component, router } = ctx
      var cookieHeader=undefined;
      if (ctx&&ctx.ctx&&ctx.ctx.req&&ctx.ctx.req.headers.cookie) cookieHeader=ctx.ctx.req.headers.cookie ;
      var token = undefined;
      if (cookieHeader){
        var cookies = cookie.parse(cookieHeader)
        if (cookies&&cookies['ptq']) token = cookies['ptq']     
      }
      let appProps = {}
      if (App.getInitialProps) {
        appProps = await App.getInitialProps(ctx)
      }
      appProps.token=token;

      // Run all GraphQL queries in the component tree
      // and extract the resulting data
      const apollo = initApollo(undefined,token)
      if (typeof window === 'undefined') {
        try {
          // Run all GraphQL queries
          await getDataFromTree(
            <App
              {...appProps}
              Component={Component}
              router={router}
              apolloClient={apollo}
            />
          )
        } catch (error) {
          // Prevent Apollo Client GraphQL errors from crashing SSR.
          // Handle them in components via the data.error prop:
          // https://www.apollographql.com/docs/react/api/react-apollo.html#graphql-query-data-error
          console.error('Error while running `getDataFromTree`', error)
        }

        // getDataFromTree does not call componentWillUnmount
        // head side effect therefore need to be cleared manually
        Head.rewind()
      }

      // Extract query data from the Apollo store
      const apolloState = apollo.cache.extract()

      return {
        ...appProps,
        apolloState
      }
    }

    constructor (props) {
      super(props)
      this.apolloClient = initApollo(props.apolloState,props.token)
    }

    render () {
      return <App {...this.props} apolloClient={this.apolloClient} />
    }
  }
}
